import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";
import $ from 'jquery';
import { DialogComponent } from '@syncfusion/ej2-react-popups';

export default class OutreachPrograms extends Component {
    constructor() {
        super();
        this.state = {
            editedId: "-1",
            data: [],
            successResp: true,
            hideDeletePopup: false,
            showDeleteAllCompletedTaskPopup: false,
            disabled: false,
            propsId: null,
            pageNum: null,
            document: null
        }
        this.dialogClose = () => {
            this.setState({
                showDeleteAllCompletedTaskPopup: false, hideDeletePopup: false
            });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        this.deleteAllCompletedTaskButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true
            }, 'click': props => {
                this.deleteAllCompletedTaskApi()
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ showDeleteAllCompletedTaskPopup: false });
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.deleteOutReachProgramApi(this.state.propsId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.topLevelIntentList = [];
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.fetchTopLevelIntentsApi();
            this.fetchOutReachProgramDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.state.disabled = false;
            thisController.fetchTopLevelIntentsApi(event.projectId);
            thisController.fetchOutReachProgramDataApi(event.projectId);
        });
    }

    deleteOutReachProgramApi = (id) => {
        let outreachPrgrmsComp = this;
        $.ajax({
            url: "/api/telephony-outreach-programs/" + id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    outreachPrgrmsComp.setState({ hideDeletePopup: false });
                    outreachPrgrmsComp.fetchOutReachProgramDataApi();
                    outreachPrgrmsComp.notifySuccess("Outreach Program deleted successfully");
                } else {
                    outreachPrgrmsComp.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status === 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deleteAllCompletedTaskApi = () => {
        var outreachPrgrmsComp = this;
        $.ajax({
            url: "/api/delete-all-completed-outbound-task",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem("currentProjectId"),
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    outreachPrgrmsComp.state.showDeleteAllCompletedTaskPopup = false;
                    outreachPrgrmsComp.setState(outreachPrgrmsComp.state);
                    outreachPrgrmsComp.notifySuccess("All completed tasks deleted successfully");
                    outreachPrgrmsComp.fetchOutReachProgramDataApi();
                } else {
                    outreachPrgrmsComp.notifyFailToLoad(res.result);
                }
            }, error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyWarning = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center"
        });
    }

    notifyEmptyFields = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            Please fill all the fields</b>, {
            position: "top-center"
        });
    }

    addRow = () => {
        this.state.data.unshift({});
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    fetchOutReachProgramDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = {
            projectId: projectId
        }
        let outreachPrgrmsComp = this;
        $.ajax({
            url: "/api/telephony-outreach-programs",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    outreachPrgrmsComp.setState({
                        data: res['result'],
                        showLoader: true,
                        disableAdd: false
                    });
                } else {
                    outreachPrgrmsComp.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    validateCells(taskName, document, initialIntent) {
        if (taskName == "" || document == null) {
            this.notifyWarning("Please fill all the fields");
            return false;
        } else if (initialIntent == "") {
            this.notifyWarning("Oops! you have not added top level intent");
            return false;
        } else {
            return true;
        }
    }

    saveOutReachProgramApi = (props, e) => {
        props.original.taskName = document.getElementById("taskName" + props.index).innerText;
        props.original.initialIntent = document.getElementById("initialIntent" + props.index).value;
        this.state.editedId = "-1";
        if (this.validateCells(props.original.taskName, this.state.document, props.original.initialIntent)) {
            var formData = new FormData();
            formData.append("projectId", localStorage.getItem("currentProjectId"));
            formData.append("taskName", props.original.taskName);
            formData.append("initialIntent", props.original.initialIntent);
            formData.append("document", this.state.document);

            var outputreachProgramsComp = this;
            $.ajax({
                url: "/api/telephony-outreach-programs",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                data: formData,
                contentType: false,
                processData: false,
                success: function (res) {
                    outputreachProgramsComp.setState(outputreachProgramsComp.state);
                    if (res.success === true) {
                        outputreachProgramsComp.setState({ disabled: false })
                        outputreachProgramsComp.fetchOutReachProgramDataApi();
                        outputreachProgramsComp.notifySuccess("Outreach Program added successfully");
                    } else {
                        outputreachProgramsComp.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    validateUpdateCells = (taskName, fileName, initialIntent) => {
        if (taskName == "" || fileName == undefined || fileName == null) {
            this.notifyWarning("Please fill all the fields");
            return false;
        } else if (initialIntent == "") {
            this.notifyWarning("Oops! you have not added top level intent");
            return false;
        } else {
            return true;
        }
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifySuccess = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center",

        });
    }

    handleChangeFile = (event, props) => {
        var outreachPrgrmsComp = this;
        props.original.taskName = document.getElementById("taskName" + props.index).innerText;
        props.original.initialIntent = document.getElementById("initialIntent" + props.index).value;
        if (event.target.files[0] != undefined && event.target.files[0] != null) {
            if (event.target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                event.target.files[0].type.includes("csv")) {
                let fileSize = (event.target.files[0].size) / 1000;
                if (fileSize < 2048) {
                    outreachPrgrmsComp.state.document = $('#fileName' + props.index)[0].files[0];
                    props.original.fileName = event.target.files[0].name;
                    outreachPrgrmsComp.setState(outreachPrgrmsComp.state);
                } else {
                    document.getElementById("fileName" + props.index).value = ""
                    this.notifyWarning("Selected file size is large");
                }
            } else {
                document.getElementById("fileName" + props.index).value = "";
                this.notifyWarning("Selected file format is not supported");
            }
        }
    }

    fetchTopLevelIntentsApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var outreachPrgrmsComp = this;
        $.ajax(
            {
                url: "/api/load-slu",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {
                    if (res.success === true) {
                        outreachPrgrmsComp.topLevelIntentList = res.result;
                        outreachPrgrmsComp.setState(outreachPrgrmsComp.state);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }

    editCell = (props, e) => {
        this.state.editedId = props.original.id;
        this.setState(this.state);
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchOutReachProgramDataApi()
        this.setState({ disabled: false })
    }

    uploadFile = (e, props) => {
        e.preventDefault();
        $("#fileName" + props.index).trigger('click');
    }


    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    handleChangeIntent = (props, e) => {
        props.original.initialIntent = e.target.value;
        this.setState(this.state);
    }

    routeToOutBoundCallTask = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/outbound-call-task',
            state: {
                batchId: props.original.id
            }
        });
        this.setState(this.setState)
    }

    render() {
        const columns = [
            {
                Header: <b>Batch name</b>,
                accessor: 'batch-name',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == null || props.original.id == this.state.editedId) ? '2px' : 'none',
                        paddingLeft: '2px'
                    }}
                    contentEditable={(props.original.id == null) ? true : (props.original.id == this.state.editedId)}
                    suppressContentEditableWarning
                    type="text" id={"taskName" + props.index}
                >{props.original.taskName}</div>
                )
            },
            {
                Header: <b>Initial intent</b>,
                accessor: 'initial-intent',
                sortable: false,
                Cell: props => (<select className="input-group form-control select2 "
                    tabIndex={-1} aria-hidden="true"
                    name="initialIntent" value={props.original.initialIntent}
                    onChange={(e) => this.handleChangeIntent(props, e)}
                    style={{ textAlign: "center", background: 'white', border: 'none', width: '98%' }}
                    id={"initialIntent" + props.index}
                    disabled={(props.original.id == null) ? false : (props.original.id != this.state.editedId)} >
                    {this.topLevelIntentList.map((topLevelIntent) => <option key={topLevelIntent.name}
                        value={topLevelIntent.name}>{topLevelIntent.name}</option>)}
                </select>
                )
            },
            {
                Header: <b>File name</b>,
                accessor: 'fileName',
                sortable: false,
                Cell: props => (
                    <div>
                        <button id="upload_link" onClick={(e) => this.uploadFile(e, props)}
                            disabled={(props.original.id == null) ? false : (props.original.id != this.state.editedId)}
                        >Choose file</button>
                        <span contentEditable={false}>{props.original.fileName}</span>
                        <input type="file"
                            style={{
                                width: '98%', padding: '2px'
                            }}
                            hidden
                            disabled={(props.original.id == null) ? false : (props.original.id != this.state.editedId)}
                            id={"fileName" + props.index}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
                            onChange={(event) => this.handleChangeFile(event, props)}

                        />
                    </div>
                )
            },
            {
                Header: <b>Status</b>,
                accessor: 'status',
                sortable: false,
                show: false,
                width: 150,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    hidden
                    suppressContentEditableWarning
                    type="text" id={"status" + props.index}
                >{props.original.status}</div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: "action",
                sortable: false,
                width: 150,
                Cell: props => (
                    <div Align="center" id="action" className='row'>
                        <button className="table-action-button" style={{ backgroundColor: "#ffffff", border: "none", display: props.original.id == null || props.original.id == undefined ? 'block' : 'none' }}
                            title="Save">
                            <img className="img-responsive" id="editOrSave"
                                style={{
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px', padding: '1px'
                                }}
                                src={this.saveImageSrc}
                                onClick={(e) => {
                                    this.saveOutReachProgramApi(props, e)
                                }}
                            />
                        </button>
                        <button className="table-action-button" style={{ display: props.original.id == null || props.original.id == undefined ? 'none' : 'block' }}
                            onClick={(e) => this.routeToOutBoundCallTask(props, e)}>
                            Manage Batch
                        </button>
                        {/* Delete Button */}
                        <button className="table-action-button" style={{ backgroundColor: "#ffffff", border: "none" }}
                            title="Delete" >
                            <img className="img-responsive" src="./assets/images/baseline_delete_white_24dp.png"
                                style={{
                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                onClick={() => (props.original.id) === undefined ?
                                    this.fetchOutReachProgramDataApi() :
                                    this.setState({
                                        hideDeletePopup: true,
                                        propsId: props.original.id
                                    })
                                }
                            />
                        </button>
                    </div>

                )
            },
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '24px', marginLeft: '2px'
                                }}>Outreach Programs</h6>
                            </div>
                            {/* Add button and refresh button*/}
                            <div className="col-sm-6" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={() => { this.setState({ showDeleteAllCompletedTaskPopup: true }) }} >
                                    Delete All Completed Task
                                </button>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow} >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-12 ">
                                    <div className="card" >
                                        <ReactTable
                                            data={this.state.data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DialogComponent width='400px' animationSettings={this.settings}
                    header='Delete All Completed Task' showCloseIcon={true} buttons={this.deleteAllCompletedTaskButton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.showDeleteAllCompletedTaskPopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete all the completed task?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>

                <DialogComponent width='400px' animationSettings={this.settings}
                    header='Outreach Program' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete the Outreach Program record?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/OutreachPrograms.js